/**
 * rellax
 */

import Rellax from 'rellax';
/* eslint-disable */
const rellax = {
    cfg: {
        class: '.rellax',
    },

    init() {
        if ($(this.cfg.class).length) {
            const rellax = new Rellax(this.cfg.class, {
                breakpoints: [600, 800, 1000]
            });
        }
    }
};

export default rellax;
/* eslint-enable */



// WEBPACK FOOTER //
// ./___src/assets/js/scripts/rellax.js